<template>
  <div class="opera-addNewEvent">
    <topNav :title="$t('addNewEvent_title')" url='/opera/eventWorm'></topNav>
    <div class="eventInfoTop">
      <mt-field :label="$t('eventInfo_descript')" :placeholder="$t('eventInfo_descript_placeholder') "v-model="saveOption.descript"></mt-field>
      <mt-field :label="$t('addNewEvent_date_con') "
                type='text' class="noInput">
        <mt-radio v-model="daySpan" :options="[this.$t('eventInfo_today'), this.$t('eventInfo_days_advance')]">
        </mt-radio>
      </mt-field>

      <div v-if='daySpan==this.$t("eventInfo_days_advance")' class="mint-cell-value prevDate">
        <input type="text" @click='openPrevDatePick("start")' v-model="startPrevTime" readonly
               :placeholder="$t('eventInfo_days_start')">
        <input type="text" @click='openPrevDatePick("stop")' v-model="stopPrevTime" readonly :placeholder="$t('eventInfo_days_stop')">

        <!-- 时间选择弹框 -->
        <mt-popup v-model="datePickValue" position="bottom" class="mint-popup-4">
          <div class="picker-toolbar">
            <span class="mint-datetime-action mint-datetime-cancel" @click="datePickValue=false">{{$t('cancel')}}</span>
            <span class="mint-datetime-action mint-datetime-confirm" @click="pickDate">{{$t('determine')}}</span>
          </div>
          <mt-picker :slots="dateSlots" :visible-item-count="5" :show-toolbar="false" :key=""
                     @change="onValuesChange"></mt-picker>
        </mt-popup>
      </div>
      <div v-if='daySpan==this.$t("eventInfo_days_advance")' class="mint-cell-value prevDate" style="height:0.5rem;">
        {{$t('eventInfo_timeListAnimation')}}
      </div>
      <transition-group name="timeListAnimation" tag="div" enter-active-class="animated fadeIn"
                        leave-active-class="animated bounceOutRight">
        <mt-field :label="$t('eventInfo_pickerValue_label')" v-model="pickerValue" type='datetime' class='timeList noInput'
                  v-for="(item,index) in timeList" :key='item.id' :class="{first:index==0}">
          <input type="text"  :placeholder="$t('eventInfo_eventTimeInput_label')" v-model='item.time' class="eventTimeInput" readonly
                 @click="openPicker(item)">
          <i class="mintui mintui-field-error" @click="delTime(item)"></i>
        </mt-field>
      </transition-group>

      <div class="addEventTime">
        <mt-button type="primary" size="large" @click='addNewTime'>{{$t('eventInfo_addEventTime')}}</mt-button>
      </div>

      <mt-datetime-picker ref="pickerEventTime" v-model="defaultTime" type="time"
                          @confirm="pickTime"></mt-datetime-picker>
    </div>

    <div class="eventInfoBody">
      <transition-group name="conditionsList" tag="div" enter-active-class="animated flipInX"
                        leave-active-class="animated bounceOutLeft">
        <div v-for='(item,key) in conditions' class="eventInfoBodyItem" :key='key'>
          <div class="top">{{$t('eventInfo_conditions')}}{{key+1}}
            <span @click='delEventBodyItem(item)'>&nbsp;X</span>
          </div>
          <div class="body">
            <mt-field :label="$t('eventInfo_quotaDescript') "
                      :placeholder="$t('eventInfo_quotaDescript') " v-model="item.quotaDescript" readonly
                      @click.native="Popcondition(item,key)"></mt-field>
            <mt-field :label="$t('eventInfo_operation') "
                      :placeholder="$t('eventInfo_operation') " v-model="item.operation" readonly
                      @click.native="Popquota(item,key)"></mt-field>
            <template v-if="item.operation=='between'">
              <mt-field :label="$t('eventInfo_valLeft')"
                        :placeholder="$t('eventInfo_valLeft')" v-model="item.valLeft" type="number"
                        pattern="[0-9]* "></mt-field>
              <mt-field :label="$t('eventInfo_valRight')"
                        :placeholder="$t('eventInfo_valRight_placeholder')" v-model="item.valRight" type="number"
                        pattern="[0-9]*"></mt-field>
            </template>
            <template v-else>
              <mt-field :label="$t('eventInfo_val')"
                        :placeholder="$t('eventInfo_val_placeholder')" v-model="item.val" type="number" pattern="[0-9]* "></mt-field>
            </template>
          </div>
        </div>
      </transition-group>

      <div class="addInfoBodyTime">
        <mt-button type="primary" size="large" @click='addNewConditions'>{{$t('eventInfo_addNewConditions')}}</mt-button>
      </div>
    </div>
    <div class="tip">
      <div class="tipHeader clearfix">
        <div class="tipHeader"><i class="iconfont icon-changfangxingbiaoqian"></i> {{$t('infoDetail_noticeContent')}}</div>
        <div class="tipSwitch">
          <mt-checklist v-model="checklistVal" :options="[this.$t('eventInfo_checklistVal')]" @change="checkon">
          </mt-checklist>
        </div>
      </div>
      <div class="tipContent">
                <textarea name="" id="tipText" cols="30" rows="5"    :placeholder="$t('eventInfo_tipContent_placeholder')"
                          v-model="saveOption.noticeContent">
                </textarea>
      </div>
    </div>
    <!-- 事件弹框 -->
    <mt-popup class="conditionPop" v-model="conditionPop" position="bottom" @touchstart.native='preventDefault'>
      <div class="picker-toolbar">
        <span class="mint-datetime-action mint-datetime-cancel" @click="conditionPop=false">{{$t('cancel')}}</span>
        <span class="mint-datetime-action mint-datetime-confirm" @click="selectcondition">{{$t('determine')}}</span>
      </div>
      <div class="reportQuotaMap">
        <mt-picker :slots="conditionsSolt" @change="conditionChange"></mt-picker>
      </div>
    </mt-popup>
    <!-- 指标弹框 -->
    <mt-popup class="quotaPop" v-model="quotaPop" ref="zhibiao" position="bottom" @touchstart.native='preventDefault'>
      <div class="picker-toolbar">
        <span class="mint-datetime-action mint-datetime-cancel" @click="quotaPop=false">{{$t('cancel')}}</span>
        <span class="mint-datetime-action mint-datetime-confirm" @click="selectquotaPop">{{$t('determine')}}</span>
      </div>
      <div class="reportQuotaMap">
        <mt-picker :slots="operationSolt" @change="operatioChange"></mt-picker>
      </div>
    </mt-popup>
    <div class="saveRule" @click="saveRule">
      {{$t('save')}}

    </div>
  </div>
</template>
<script>
  import _ from 'lodash';
  import moment from 'moment';
  import {Toast} from 'mint-ui';

  export default {
    data() {
      return {
        conditionPop: false,//条件弹框
        quotaPop: false,//指标弹框
        checklistVal: [this.$t('eventInfo_checklistVal')], //是否启用
        pickerValue: '',
        datePickValue: false,
        pickerValue4: '',
        defaultTime: '18:00',
        reportQuotaMap: [],//指标选项
        startPrevTime: '',//提前天数--起始
        stopPrevTime: '',//提前天数--结束
        timeList: [
          {id: 0, time: ''},
        ],
        dateList: [
          {id: 0, time: moment().format('HH mm')},
        ],
        conditions: [//判断条件
          {
            "multi": false,
            "operation": "",
            "quota": "",
            "quotaDescript": "",
            "val": "",
            "valLeft": "",
            "valRight": ""
          }
        ],
        conditionsSolt: [{ //事件指标
          flex: 1,
          values: [],
          code: [],
          className: 'condition',
          textAlign: 'center'
        }],
        operationSolt: [{ //事件条件
          flex: 1,
          values: ['between', '>', '<', '<=', ">="],
          className: 'operation',
          textAlign: 'center',
          defaultIndex: 1
        }],
        selectoperation: '',//被选中的指标
        selectEvcondition: '',//被选中的条件
        selectEvKey: '',//被选中的事件
        dateSlots: [
          {
            flex: 1,
            values: [],
            className: 'slot3',
            textAlign: 'center'
          }
        ],
        selectItem: '',
        selectDate: '',
        pickType: '',
        daySpan: "当天",
        saveOption: {//保存规则请求参数
          isHalt: 'F',
          triggerType: 'ALERT',
        },
        dataIndex: ''
      }
    },
    mounted() {
      var array = []
      _.times(30, function (index) {//设置可提前天数选项
        array.push(index + 1)
      });
      this.dateSlots[0].values = array;
      this.init();

    },
    methods: {
      //init信息
      init() {
        this.$http.get('/mobilepmsapi/message/getQuotas?way=opera').then(res => {
          if (res.data.result == 0) {
            this.reportQuotaMap = res.data.retVal;
            _.forEach(this.reportQuotaMap, (el, index) => {
              this.conditionsSolt[0].values.push(el)
              this.conditionsSolt[0].code.push(index)
            })
          } else {
            console.log('获取条件失败')
          }
        })
      },
      //条件确认
      selectcondition() {
        let repeat = false;
        _.forEach(this.conditions, (el, index) => {
          if (el.quotaDescript == this.selectEvcondition) {
            repeat = true;
          }
        })
        if (repeat) {
          Toast(this.$t("Toast_selectcondition"));
          return;
        }
        this.conditions[this.selectEvKey].quotaDescript = this.selectEvcondition
        this.conditions[this.selectEvKey].quota = this.conditionsSolt[0].code[this.dataIndex]
        this.conditionPop = false;
      },
      //指标确认
      selectquotaPop() {
        this.conditions[this.selectEvKey].operation = this.selectoperation
        this.quotaPop = false;
      },
      preventDefault(e) {
      },
      //弹框
      openPicker(item) {
        if (item.time) {
          this.defaultTime = item.time;
        }
        this.$refs.pickerEventTime.open();
        this.selectItem = item;
      },
      //提前天数的弹框
      openPrevDatePick(value) {
        this.datePickValue = true;
        this.pickType = value;
        // console.log('提前天数')
      },
      //分割时间
      pickTime(value) {
        _.filter(this.timeList, n => {
          if (n.id == this.selectItem.id) {
            n.time = value
          }
        })
      },
      //选定提前天数时间
      pickDate(value) {
        if (this.pickType == 'start') {
          this.startPrevTime = this.selectDate;
          if (this.stopPrevTime != '' && this.stopPrevTime <= this.selectDate) {
            this.stopPrevTime = this.selectDate + 1
          } else if (this.stopPrevTime > this.selectDate + 5) {
            Toast(this.$t("Toast_pickDate"));
            // this.stopPrevTime=this.selectDate+5
            return;
          }
          this.datePickValue = false;
        } else {
          if (this.startPrevTime > this.selectDate) {
            Toast(this.$t("Toast_pickDate1"));
          } else if (this.startPrevTime + 5 < this.selectDate) {
            Toast(this.$t("Toast_pickDate"));
          } else {
            this.stopPrevTime = this.selectDate;
            this.datePickValue = false;
          }
        }
      },
      //添加时间
      addNewTime() {
        // if()
        // console.log(this.timeList.length);
        if (this.timeList.length > 2) {
          Toast(this.$t("Toast_addNewTime"));
          return;
        }

        var newIndex = _.last(this.timeList).id + 1;
        let newTime = {id: newIndex, time: ''}
        this.timeList.push(newTime)
      },
      checkCondition() {
        for (var i = 0; i < this.conditions.length; i++) {
          var el = this.conditions[i];
          if (el.quotaDescript == '' || el.operation == 'between' && (el.valLeft == '' || el.valRight == '') ||
            el.operation != 'between' && el.operation != '' && el.val == '' ||
            el.operation == '') {
            Toast(this.$t("Toast_checkCondition"));
            return false;
          }
          if (el.operation == 'between' && parseFloat(el.valLeft) >= parseFloat(el.valRight)) {
            Toast(this.$t("Toast_checkCondition2"));
            return false;
          }
        }
        return true;
      },
      //新增判断条件
      addNewConditions() {
        // var newIndex = _.last(this.conditions).id + 1;
        if (!this.checkCondition()) {

          return false;
        }
        var condition = {
          "multi": false,
          "operation": "",
          "quota": "",
          "quotaDescript": "",
          "val": "",
          "valLeft": "",
          "valRight": ""
        }
        this.conditions.push(condition)
      },
      //删除时间
      delTime(item) {
        if (this.timeList.length > 1) {
          var index = _.indexOf(this.timeList, item)
          // console.log(index)
          this.timeList.splice(index, 1)

        } else {
          Toast(this.$t("Toast_del_last"));
        }
      },
      //删除事件
      delEventBodyItem(item) {
        if (this.conditions.length > 1) {
          var index = _.indexOf(this.conditions, item)
          this.conditions.splice(index, 1)

        } else {
          Toast(this.$t("Toast_del_last"));
        }
      },

      onValuesChange(picker, values) {
        this.selectDate = picker.getValues()[0]
      },

      conditionChange(picker, values) {
        this.selectEvcondition = values[0];
        // console.log(picker)
        if (picker.$children.length != 0)
          this.dataIndex = picker.$children[0].valueIndex
      },
      operatioChange(picker, values) {
        this.selectoperation = values[0];
      },
      //是否启用提醒
      checkon() {
        // console.log(this.checklistVal);
        // console.log(this.saveOption)
        if (!!this.checklistVal && this.checklistVal[0] == '是否启用') {
          this.saveOption.isHalt = 'T'
        } else {
          this.saveOption.isHalt = 'F'
        }

      },
      //选定修改的条件
      Popcondition(item, key) {
        console.log(key)
        // this.selectEvcondition=item;
        this.selectEvKey = key;
        this.conditionPop = true;
      },
      //选定修改的条件
      Popquota(item, key) {
        // this.selectEvcondition=item;
        this.selectEvKey = key;
        this.quotaPop = true;
        console.log(this.quotaPop)
      },

      saveRule() {
        this.saveOption.pushmsgDatetime = [];
        _.forEach(this.timeList, (el, index) => {
          this.saveOption.pushmsgDatetime.push(el.time);
        })
        if (!this.saveOption.descript) {
          Toast(this.$t("Toast_save_rule"));
          return;
        }

        if (this.daySpan == this.$t("eventInfo_today")) {
          this.saveOption.daySpan = '0~0';
        } else {
          if (this.startPrevTime == '' || this.stopPrevTime == '') {
            Toast(this.$t("Toast_save_rule1"));
            return;
          } else {
            this.saveOption.daySpan = this.startPrevTime + '~' + this.stopPrevTime;
          }
        }

        if (this.saveOption.pushmsgDatetime[0] == '') {
          Toast(this.$t("Toast_save_rule_time"));
          return;
        }

        if (!this.saveOption.noticeContent) {
          Toast(this.$t("Toast_noticeContent"));
          return;
        }
        if (!this.checkCondition()) {
          return false;
        }
        this.saveOption.conditions = this.conditions;
        console.log(this.saveOption)
        this.$http.post('/mobilepmsapi/message/setMessageTrigger', this.saveOption).then(res => {
          console.log(res)
          if (res.data.result == '0') {
            Toast(this.$t("Toast_save_success"));
            this.$router.push('/opera/eventWorm')
          } else {
            Toast(res.data.msg);
          }
        })
      }

    },
    computed: {},

  }
</script>
<style lang='less'>
  .opera-addNewEvent {
    // background: #eee;
    background-color: #f7f8fa;

    .mint-popup-bottom {
      width: 100%;
    }

    .addInfoBodyTime {
      width: 93%;
      margin: 10px auto;

      .mint-button {
        height: 34px;
        background-color: #fff;
        border: 1px dashed #ccc;

        // .mint-button-text{
        //     // font-size: .4rem!important;
        // }
        button {
          width: 100%;
          background-color: #fff;
          border: 1px dashed #ddd;
        }

        .mint-button-text {
          font-size: 0.32rem; // color: #fff;
          color: #999;
          line-height: 18px;
        }
      }
    }

    .prevDate {
      justify-content: flex-end;
      margin-right: 13%;

      input {
        width: 33%;
        height: 0.5rem;
        min-height: 0.7rem !important;
        margin-left: 10px;
        float: flex-end;
      }
    }

    .eventInfoTop {
      border-bottom: 1px solid #ccc;
      background: #fff;
      padding-bottom: 0.4rem;
      padding-top: 21px;

      .mint-cell-value {
        input {
          border: 1px solid #ccc;
          min-height: 0.9rem;
          text-indent: 1em;
          border-radius: 5px;
          box-sizing: border-box;
          outline: none;
        }
      }

      .addEventTime {
        margin-left: 2.3rem;
        margin-right: 0.5333rem;
        margin-top: 0.1333rem;

        button {
          margin: 0 10px;
          width: 85%;
          background-color: #fff;
          border: 1px dashed #ddd;
        }

        .mint-button-text {
          font-size: 0.32rem; // color: #fff;
          color: #999;
          line-height: 18px;
        }
      }

      .mint-cell-wrapper {
        background-image: none;
        font-size: 0.3rem;

        > .mint-cell-title {
          width: 2.3rem;
        }
      }

      .timeList {
        .mint-cell-title {
          visibility: hidden;
        }
      }

      .first {
        .mint-cell-title {
          visibility: visible;
        }
      }

      .noInput {
        margin: 5px 0;

        .mint-field-other {
          width: 100%;
        }

        .eventTimeInput {
          flex: 1;
          width: 85%;
        }

        .mintui-field-error {
          color: #666;
          margin-left: 3px;
        }

        .mint-radiolist-label {
          margin: 0;
          padding: 0;
        }

        .mint-radiolist-title {
          display: none;
        }

        .mint-cell {
          background: none;
          margin-right: 1rem;

          .mint-cell-wrapper {
            margin: 0;
            padding: 0;

            .mint-cell-title {
              width: 2.7rem;

              .mint-radio-core {
                width: 16px;
                height: 16px;
              }

              .mint-radio-input:checked + .mint-radio-core {
                background: #fff;
                border-color: #ddd;

                &::after {
                  background-color: #f5a624;
                  transform: scale(1);
                  top: ~"calc(100% - 16px)";
                  right: 0;
                  top: 3px;
                  margin: 0 auto;
                  left: 0;
                }
              }
            }
          }
        }

        .mint-field-core {
          display: none;
        }

        .mint-radiolist {
          display: flex;
          justify-content: space-between;
        }
      }

      .mint-cell {
        background: none;
        min-height: 36px;
      }
    }

    .eventInfoBody {
      margin-top: 20px;
      background-color: #f7f8fa;
      padding-bottom: 1px;

      .eventInfoBodyItem {
        margin-top: 15px;

        .mint-cell-text {
          font-size: 0.4rem !important;
        }
      }

      .top {
        background: #f5a624;
        border-radius: 5px 5px 0 0;
        width: 2.7rem;
        height: 0.7rem;
        line-height: 0.66rem;
        text-align: center;
        color: #fff;
        margin-left: 7%;
      }

      .body {
        border: 1px solid #ccc;
        border-radius: 0.09rem;
        overflow: hidden;

        .mint-cell-text {
          font-size: 0.4rem;
        }

        .mint-cell-title {
          width: 2rem;
        }

        width: 92%;
        margin: 0 auto;
      }
    }

    .tip {
      background-color: #fff;
      border-top: 1px solid #ccc;

      .tipHeader {
        height: 43px;
        background-color: #fff;

        .tipHeader {
          float: left;
          position: relative;
          line-height: 43px;
          padding-left: 13px;

          .iconfont {
            color: #f5a624;
            line-height: 43px;
            position: absolute;
            left: -7px;
          }
        }

        .tipSwitch {
          float: right;
          line-height: 43px;

          .mint-cell {
            min-height: 20px;
            background: none;

            .mint-cell-wrapper {
              background: none;
            }
          }

          .mint-checkbox-core {
            width: 16px;
            height: 16px;
            border-radius: 0;
            background-color: #fff;
            border-color: #ddd;

            &::after {
              border-color: #f5a624;
              top: -1px;
              left: 5px;
              position: absolute;
              width: 5px;
              height: 10px;
            }
          }

          .mint-checkbox-label {
            font-size: 12px;
            color: #333;
          }

          .mint-checklist-label {
            padding-right: 4px;
          }
        }
      }

      .tipContent {
        text-align: center;
        padding-bottom: 14px;

        #tipText {
          padding: 9px 12px;
          width: 90%;
          text-align: left;
          outline: none;
          border-radius: 0.08rem;
        }
      }
    }
    .eventInfoBodyItem .mint-cell {
      background: none;
      min-height: 36px;
    }
    .eventInfoBodyItem .body{ background:#fff;}
    .eventInfoBodyItem .body .mint-cell{margin:10px 0 15px 0;border: none;}
    .eventInfoBodyItem  .mint-cell-wrapper {
      height:30px;line-height:30px;
      background-image: none;
      font-size: 0.3rem;
      border: none;
    }
    .eventInfoBodyItem  .mint-cell-wrapper input{border: 1px solid #ccc;
      min-height: 0.85rem;
      text-indent: 1em;
      border-radius: 5px;
      box-sizing: border-box;
      outline: none;}
    .saveRule {
      height: 45px;
      background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);
      text-align: center;
      color: #fff;
      font-size: 16px;
      line-height: 45px;
    }
  }

  .conditionPop {
    .picker-toolbar {
      position: flex;
      top: 0;
      width: 100%;
    }

    .reportQuotaMap {
      overflow: auto;
      height: 200px;

      .cell {
        height: 30px;
        text-align: center;
        font-size: 16px;
        color: #333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// addNewEvent.vue?51d32eda